import { simplePath } from "../../utils.js";
const GET_ORG_COUNTERS = 'v2/organization/:organization/counters';
function get_org_counters_path(params) {
    return simplePath(GET_ORG_COUNTERS, params);
}
export { GET_ORG_COUNTERS, get_org_counters_path };
